import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import './App.css';
import Api from './Api';
import Auth from './Auth';
import CheckIn from './CheckIn';
import TeamPanel from './TeamPanel';
import Welcome from './Welcome';

const TeamRoute = ({ component: Component, compProps, ...rest }) => (
  <Route {...rest} render={props => {
    if (Auth.isTeam) {
      return <Component {...props}/>;
    }
    if (Auth.isTeam === undefined) {
      return <div/>;
    }
    return <Redirect to={{ pathname: '/' }}/>;
  }}/>
);

const PrivateRoute = ({ component: Component, compProps, ...rest }) => (
  <Route {...rest} render={(props) => {
    const mergedProps = Object.assign({}, rest, props);
    return Auth.isAuth() ? (
      <Component {...mergedProps}/>
    ) : (
      <Redirect to={{
        pathname: '/checkin',
        state: { from: props.location },
        }}/>
    );
  }}/>
);

const NoMatch = () => (
  <Redirect to="/" />
);

class App extends Component {

  constructor(props, context) {
    super(props, context);
    Auth.checkAndConvertAuthTokenCookie();

    this.state = {
      isAuth: Auth.isAuth(),
    };

    if (Auth.isAuth()) {
      Api.fetchEventInfo()
        .then(this._handleLogin);
    } else {
      Auth.setIsTeam(false);
    }
    Api.addLoginListener(this._handleLogin);
    Api.addGuestUpdateListener(this._handleGuestUpdate);
  }

  _handleLogin = result => {
    this.setState({
      isAuth: result && !result.code,
      isTeam: result && result.is_team,
    });
    if (!this.state.isAuth) return;
    Auth.setIsTeam(result.is_team);
    this.setState({
      eventInfoHtml: result.html,
      sections: result.sections,
      guests: result.guests,
      invitation: result.invitation,
      mealChoices: result.meal_choices,
      videoSrc: result.video_url,
    });
  }

  _handleGuestUpdate = (guestId, updates) => {
    let guests = this.state.guests.slice();
    for (let i = 0; i < guests.length; i++) {
      let guest = guests[i];
      if (guest.guest_id === guestId) {
        guests[i] = Object.assign({}, guest, updates);
        break;
      }
    }
    this.setState({ guests });
  }

  render() {
    return (
      <Router>
        <div className="App">
          <Switch>
            <TeamRoute path="/team" component={TeamPanel}/>
            <Route path="/checkin" component={CheckIn}/>
            <PrivateRoute exact path="/" component={Welcome} {...this.state}/>
            <Route component={NoMatch}/>
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js